// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageAdminVacations table {\n  border-spacing: 0;\n  border-collapse: collapse; }\n  .PageAdminVacations table th {\n    padding: 4px;\n    border: 1px solid black;\n    font-weight: normal;\n    font-size: smaller;\n    background: aliceblue; }\n  .PageAdminVacations table td {\n    padding: 4px;\n    border: 1px solid black; }\n", ""]);
// Exports
module.exports = exports;
